import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Input, ButtonGroup, Button } from "reactstrap";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import { FilterBubbles, DynamicTable } from "@workspace/common";
import {
  JOB_APP_INITIAL_OPTIONS,
  JOB_APP_LABELS,
  generateJobAppFields,
  jobAppForm,
} from "../PulseApplicationContent/PulseApplicationContentConstants";
import {
  fetchJobAppCustomView,
  resetJobAppCustomView,
  deleteJobAppDefaultCustomView,
  deleteJobAppCustomViewById,
} from "../../store/actions";
import CustomViewCanvas from "../PulseApplicationContent/CustomViewCanvas/CustomViewCanvas";

export default function DynamicTableWrapper(props) {
  const {
    data,
    config,
    pageInfo,
    pageRequest,
    pageRequestSet,
    search,
    setSearch,
    setCustomConfigData,
    gridView,
    handleTableViewChange,
    setTableConfig,
    activeRow,
    // setActiveRow,
  } = props;
  const dispatch = useDispatch();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  //Get data from Redux store
  const jobAppDefaultCustomView = useSelector(
    (state) => state.JobApplicationReducer.jobAppDefaultCustomView
  );
  const allJobAppCustomViews = useSelector(
    (state) => state.JobApplicationReducer.jobAppCustomViews
  );

  // Set custom view data
  useEffect(() => {
    const jobFields = generateJobAppFields(jobAppForm);
    if (allJobAppCustomViews != null && allJobAppCustomViews.length > 0) {
      const selectedCustomView = allJobAppCustomViews?.find(
        (customView) => customView?.selected
      );
      if (selectedCustomView && jobFields && jobFields?.length > 0) {
        const selectedGroup = selectedCustomView?.columnName?.split(",");
        const selectedObjects = selectedGroup?.map((value) => {
          return jobFields?.find((option) => option?.value === value);
        });
        if (selectedObjects.length > 0) {
          setCustomConfigData(selectedObjects);
        }
        pageRequestSet.setFilterData(selectedCustomView?.filters);
      } else if (!selectedCustomView) {
        if (
          jobAppDefaultCustomView?.columnName &&
          jobAppDefaultCustomView?.columnName?.length > 0
        ) {
          const selectedObjects = jobAppDefaultCustomView?.columnName?.map(
            (value) => {
              return jobFields?.find((option) => option?.value === value);
            }
          );
          setCustomConfigData(selectedObjects);
        } else {
          enableDefaultView();
        }

        pageRequestSet.setFilterData(jobAppDefaultCustomView?.filters ?? []);
        pageRequestSet.setExternalFilterData(
          jobAppDefaultCustomView?.externalFilters ?? []
        );
      }
    }

    if (allJobAppCustomViews != null && allJobAppCustomViews.length === 0) {
      if (
        jobAppDefaultCustomView?.columnName &&
        jobAppDefaultCustomView?.columnName?.length > 0
      ) {
        const selectedObjects = jobAppDefaultCustomView?.columnName?.map(
          (value) => {
            return jobFields?.find((option) => option?.value === value);
          }
        );
        setCustomConfigData(selectedObjects);
      } else {
        setCustomConfigData(JOB_APP_INITIAL_OPTIONS);
      }
      pageRequestSet.setFilterData(jobAppDefaultCustomView?.filters ?? []);
      pageRequestSet.setExternalFilterData(
        jobAppDefaultCustomView?.externalFilters ?? []
      );
    }
  }, [allJobAppCustomViews, jobAppDefaultCustomView]);

  // Fetch custom view data
  useEffect(() => {
    dispatch(fetchJobAppCustomView());
    return () => {
      dispatch(resetJobAppCustomView());
      dispatch(deleteJobAppDefaultCustomView());
    };
  }, []);

  // Enable default view
  const enableDefaultView = () => {
    setCustomConfigData(JOB_APP_INITIAL_OPTIONS);
    pageRequestSet.setFilterData(null);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg="12">
            <div
              className="d-flex flex-column"
              style={{ height: "calc(100vh - 160px)" }}
            >
              <Row className="mb-2">
                <Col>
                  <h4 style={{ whiteSpace: "nowrap" }}>
                    <span>{`${JOB_APP_LABELS[gridView] ?? "Job Application"} (${
                      pageInfo?.totalElements ?? 0
                    })`}</span>
                  </h4>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col lg="6" className="d-flex gap-2">
                  <div className="search-box">
                    <form onSubmit={pageRequestSet.setSearchTerm}>
                      <Input
                        type="text"
                        placeholder="Search"
                        className="form-control"
                        value={search}
                        style={{
                          width: "210px",
                          height: "40px",
                          borderColor: "#d3d3d3",
                        }}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </form>
                    <i className="ri-search-line search-icon"></i>
                  </div>
                  <div className="select-width">
                    <Input
                      type="select"
                      className="form-select border-secondary"
                      onChange={handleTableViewChange}
                      value={gridView}
                      style={{ width: "210px", height: "40px" }}
                    >
                      <option value="">All Job Applications</option>
                      <option value="new">New Job Applications</option>
                      <option value="approved">
                        Approved Job Applications
                      </option>
                      <option value="rejected">
                        Rejected Job Applications
                      </option>
                    </Input>
                  </div>
                </Col>
                <Col
                  lg="6"
                  className="d-flex justify-content-end align-items-center"
                >
                  <TableItemDisplay pageInfo={pageInfo} />
                  <div
                    style={{
                      width: "2px",
                      height: "20px",
                      backgroundColor: "#adb5bd",
                      marginLeft: "12px",
                    }}
                  ></div>
                  <TableRowsPerPageWithNav
                    pageInfo={pageInfo}
                    pageRequestSet={pageRequestSet}
                  />
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  className="d-flex flex-row justify-content-between align-items-center"
                  style={{ fontSize: "12px" }}
                >
                  <FilterBubbles
                    setBubbleExternalFilter={props?.setJobFilterBubble}
                    bubbleExternalFilter={props?.jobFilterBubble}
                  />
                </Col>
              </Row>
              <DynamicTable
                config={config}
                data={data}
                pageRequestSet={pageRequestSet}
                pageInfo={pageInfo}
                freezeHeader={true}
                activeRow={activeRow}
                setTableConfig={setTableConfig}
                pageRequest={pageRequest}
                tableHeight="100%"
              />
            </div>
          </Col>
        </Row>
        <CustomViewCanvas
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          jobAppCustomView={props?.jobAppCustomView}
          setJobAppCustomView={props?.setJobAppCustomView}
          jobAppDefaultCustomView={props?.jobAppDefaultCustomView}
          setJobAppBubbleFilter={props?.setJobAppFilterBubble}
        />
      </Container>
    </div>
  );
}
